module.exports = __webpack_public_path__ + "static/media/aboutUs_20.dd94d0cb.jpg";